import React from 'react';
import { processSteps } from '../data/process';
export function ProcessSection() {
  return <section id="ablauf" className="py-16 lg:py-28 bg-[#0a0e1a] scroll-mt-16" data-id="element-178" data-mp="z0h4uwocaop4">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-179" data-mp="u1xk2zlhfiyc">
        <div className="max-w-3xl mb-12 lg:mb-16" data-id="element-180" data-mp="u25wkqdp0m90">
          <h2 className="text-3xl lg:text-5xl font-bold text-white mb-5" data-id="element-181" data-mp="p3ch4seuil67">
            Close CRM einrichten lassen – ohne Copy-Paste-Setup
          </h2>
          <p className="text-gray-400 text-lg leading-relaxed" data-id="element-182" data-mp="1mptaxnodegn7">
            Natürlich haben wir Vorlagen und ein bewährtes Performance-Setup.
            Aber verschiedene Produkte, Zielgruppen und Vertriebsprozesse
            brauchen verschiedene Lösungen.
          </p>
        </div>

        <ol className="grid md:grid-cols-5 gap-8 md:gap-6" data-id="element-183" data-mp="1815ivrdqgp20">
          {processSteps.map((step, i) => <li key={step.title} className="relative" data-id="element-184" data-mp="25idq62b5cn8j" data-mpi={i}>
              <div className="flex items-center gap-4 mb-5" data-id="element-185" data-mp="20q44wzkz8bcl">
                <span className="w-10 h-10 rounded-full bg-[#ff6b35] text-white font-bold flex items-center justify-center flex-shrink-0" data-id="element-186" data-mp="20ojad9ynwseq">
                  {i + 1}
                </span>
                {i < processSteps.length - 1 && <span className="hidden md:block h-px flex-1 bg-white/10" aria-hidden="true" data-id="element-187" data-mp="1wdctropcgy0r" />}
              </div>
              <h3 className="text-lg font-semibold text-white mb-2" data-id="element-188" data-mp="21a37449rlfih">{step.title}</h3>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-189" data-mp="1nb3n59x75osn">{step.description}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}